import React from 'react';

import { SystemMessage } from './SystemMessage';
import styles from './MessageContainer.module.scss';

export interface MessageProps {
    id: string;
    text: string;
    type?: 'success' | 'error';
}

interface MessageContainerProps {
    messages: Array<MessageProps>;
    onClose?: (messageId: string) => void;
}

export const MessageContainer = ({ messages, onClose }: MessageContainerProps) => {
    return (
        <div className={styles.messageContainer}>
            {messages.map(message => (
                <SystemMessage key={message.id} onClose={onClose} message={message} />
            ))}
        </div>
    );
};
